/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import {
  type ProductGranularity,
  ProductGranularitySchema,
} from '../shared/product-granularity'
import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type CmsIcon, CmsIconSchema } from './icon'
import { type Image, ImageSchema } from './image'
import { type ProductQuery, ProductQuerySchema } from './product-query'
import type { RichText } from './rich-text'

/* TypeScript */
export type ProductSpotlightCtaApiProps = {
  technicalName?: Maybe<string>
  label: string
  variant?: Maybe<'primary' | 'secondary'>
  form?: Maybe<'square' | 'link'>
  link: ContentLink
}

export type ProductSpotlightApiProps = {
  technicalName?: Maybe<string>
  eyebrowText?: Maybe<string>
  tag?: Maybe<string>
  title: RichText
  subtitle?: Maybe<RichText>
  image?: Maybe<Image>
  productFilters: ProductQuery
  productGranularity?: Maybe<ProductGranularity>
  ctaList?: Maybe<ProductSpotlightCtaApiProps[]>
}

/* Schemas */
export const ProductSpotlightCtaPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  label: z.string(),
  variant: z.nullish(z.enum(['primary', 'secondary'])),
  form: z.nullish(z.enum(['square', 'link'])),
  link: ContentLinkSchema,
})

export const ProductSpotlightPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  eyebrowText: z.nullish(z.string()),
  tag: z.nullish(z.string()),
  title: LooseRichTextSchema,
  subtitle: z.nullish(LooseRichTextSchema),
  image: z.nullish(ImageSchema),
  productFilters: ProductQuerySchema,
  productGranularity: z.nullish(ProductGranularitySchema),
  ctaList: z.nullish(z.array(ProductSpotlightCtaPropsSchema)),
})

/* Schemas validation */
type TestModularCardsCarouselProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<ProductSpotlightApiProps>,
    z.infer<typeof ProductSpotlightPropsSchema>
  >
>
